import React, { useState, useEffect } from "react";
import { API_URL } from "../../../../constants";
import CustomDatePicker from "../../../../components/Custom-Datepicker";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import * as Yup from "yup";
import { FaSpinner } from "react-icons/fa";
import { Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";
import { components } from "react-select";

const Add_PR_Appraisal = () => {
  const initialFormData = {
    Name: "",
    Code: "",
    Description: "",
    FromDate: null,
    ToDate: null,
    AppraisalCycleProcessType: "",
    selectedOption: null,
    AppraisalCycleType: null,
    Active: 1,
    checkedItems: [],
    lines: [{ LineNo: 1, AppraisalTemplateMasterID: "", EmployeeID: "" }],
  };

  const navigate = useNavigate();
  const dispatch = useDispatch()
  useEffect(() => {
    fetchAppraisal();
    dispatch(updateNavbarHeading("PR Appraisal Cycle"))
  }, []);
  const [EmployeeListdata, setEmployeeListdata] = useState([]);
  const [templateOption, setTemplateOption] = useState([]);
  const [errors, setErrors] = useState({});
  const [appraisalCycleTypeOption, setAppraisalCycleTypeOption] = useState([])
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState(initialFormData);
  console.log("formData:::", formData);


  const fetchAppraisal = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}appraisal-cycles`);

      if (response?.status == 200) {
        // employee list
        const employeeData = response?.data?.data?.employee_list;

        const newEmployeeListData = [
          { value: '', label: "Select ALL" },
          ...employeeData.map((ele) => ({
            value: ele?.value,
            label: ele?.text,
          }))
        ];

        setEmployeeListdata(newEmployeeListData);

        const templateOption = response?.data?.data?.template_list.map(
          (item) => ({
            value: item.value,
            label: item.text,
          })
        );
        setTemplateOption(templateOption);
        const appraisalCycleTypeOption = Object.entries(response?.data?.data?.appraisalCycleTypes || {}).map(
          ([key, value]) => ({
            value: parseInt(key, 10), // Convert key to number if needed
            label: value,
          })
        );

        setAppraisalCycleTypeOption(appraisalCycleTypeOption)

      }
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };

  const transformData = (inputData) => {
    let result = [];
    let lineNo = 1;

    inputData.forEach(item => {
      // Handle comma-separated EmployeeID values
      if (typeof item.EmployeeID === 'string' && item.EmployeeID.includes(',')) {
        const employeeIds = item.EmployeeID.split(',').map(id => parseInt(id.trim()));
        employeeIds.forEach(employeeId => {
          result.push({
            LineNo: lineNo++,
            AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
            EmployeeID: employeeId
          });
        });
      } else if (Array.isArray(item.EmployeeID)) {
        // Handle array EmployeeID values
        item.EmployeeID.forEach(employeeId => {
          result.push({
            LineNo: lineNo++,
            AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
            EmployeeID: employeeId
          });
        });
      } else {
        // Single EmployeeID
        result.push({
          LineNo: lineNo++,
          AppraisalTemplateMasterID: item.AppraisalTemplateMasterID,
          EmployeeID: item.EmployeeID
        });
      }
    });

    return result;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {
      // Validate the entire form data
      await schema.validate(formData, { abortEarly: false });
      setErrors({}); // Clear errors before submission

      const AppraisalData = {
        Name: formData.Name,
        AppraisalCycleType: formData?.AppraisalCycleType || null,
        AppraisalCycleProcessType: formData.AppraisalCycleProcessType,
        Code: "APC/2824/0001", // Static code transfer
        Description: formData.Description,
        FromDate: formData.FromDate,
        ToDate: formData.ToDate,
        Active: formData.Active,
        lines: transformData(formData.lines),
      };

      // Call the API
      const response = await PostServiceCaller(
        `${API_URL}appraisal-cycles`,
        AppraisalData,
        "post"
      );

      if (response.status === 200) {
        // Successful response
        toast.success("PR Appraisal Cycle created successfully!");
        // toast.success("Data submitted successfully");
        setTimeout(() => {
          navigate("/appraisal-cycles")
        }, 2000);
      } else {
        // Handle non-200 status codes
        toast.error("PR Appraisal Cycle not created!");
      }
    } catch (error) {
      // Handle validation errors and other issues
      if (error.name === "ValidationError") {
        error.inner.forEach((e) => {
          setErrors((prev) => ({ ...prev, [e.path]: e.message }));
        });
      } else {
        console.error("Error:", error);
        toast.error("Sorry, there was an issue with your request.");
      }
    } finally {
      setLoading(false); // Ensure loading is stopped in both success and failure
    }
  };

  const schema = Yup.object().shape({
    Name: Yup.string().required("Name is required"),
    Description: Yup.string(),
    FromDate: Yup.date().required("From Date is required"),
    ToDate: Yup.date().required("To Date is required"),
    AppraisalCycleProcessType: Yup.string().required("Appraisal Type is required"),
    AppraisalCycleType: Yup.number().typeError("Appraisal Cycle Type is required").required('Appraisal Cycle Type is required').nullable(),
  });

  // Validate individual fields
  const validateField = async (name, value) => {
    try {
      await schema.validateAt(name, { ...formData, [name]: value });
      setErrors((prev) => ({ ...prev, [name]: "" }));
    } catch (err) {
      setErrors((prev) => ({ ...prev, [name]: err.message }));
    }
  };

  const handleFormChange = async (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate only the changed field
    await validateField(name, value);
  };

  const handleAppraisalLineSelectChange = (option, name, index) => {
    const updatedLines = formData.lines.map((item, idx) =>
      idx === index ? { ...item, [name]: option.value } : item
    );
    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));
  };
  const handleAppraisalLineSelectChangeEmp = (option, name, index) => {
    console.log("Handler received:", option, name, index);

    // Ensure proper clearing - if option is empty string, set it as empty string
    const cleanValue = (option === "" || option === null || option === undefined || option === "0") ? "" : option;

    const updatedLines = formData.lines.map((item, idx) =>
      idx === index ? { ...item, [name]: cleanValue } : item
    );

    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));

    console.log("Updated form data:", updatedLines);
  };

  const handleAddAppraisalLine = () => {
    const currentRow = formData.lines[formData.lines.length - 1];
    if (currentRow && currentRow.AppraisalTemplateMasterID === "") {
      toast.error("Please fill in the current row.", {
        position: "top-right",
      });
      return;
    }

    setFormData((prevState) => ({
      ...prevState,
      lines: [
        ...prevState.lines,
        {
          LineNo: formData.lines.length + 1,
          AppraisalTemplateMasterID: "",
          EmployeeID: "",
        },
      ],
    }));
  };

  const handleDeleteAppraisalLine = (index) => {
    const updatedLines = formData.lines.filter((_, idx) => idx !== index);
    setFormData((prevFormData) => ({
      ...prevFormData,
      lines: updatedLines,
    }));
  };



  const handleSelect = async (e, name) => {
    const value = e.value;

    setFormData((prevState) => ({
      ...prevState,
      [name]: value, // Update formData with the selected value
    }));
    // Optional: Handle errors if no value is selected
    if (!value) {
      setErrors((errors) => ({
        ...errors,
        [name]: "This field must be selected.",
      }));
    }
    await validateField(name, value);
  };


  const Option = (props) => {
    return (
      <components.Option {...props}>
        <div
          style={{
            backgroundColor: props.isSelected ? "#27568c" : "transparent",
            color: props.isSelected ? "#ffffff" : "#000000",
            
            display: "flex",
            alignItems: "center",
          }}
        >
          <input
            type="checkbox"
            className="me-2"
            checked={props.isSelected}
            onChange={() => null}
          />
          <label>{props.label}</label>
        </div>
      </components.Option>
    );
  };


  return (
    <>

      <div className="Container" >
        <form
          id="formOne"
          onSubmit={handleSubmit}
          className="rounded bg-white mx-3 mt-3 px-3 pt-3"
        >
          <div className="row">
            <div className="col-4">
              <div className="col-12">
                <label htmlFor="Code" className="col-form-label">
                  <strong>Code</strong>
                </label>
              </div>
              <div className="col-12">
                <input
                  type="text"
                  id="Code"
                  className="form-control"
                  aria-describedby="Code"
                  disabled
                />
              </div>
            </div>
            <div className="col-4">
              <div className="col-12">
                <label htmlFor="Name" className="col-form-label">
                  <strong>
                    Name<span className="required">*</span>
                  </strong>
                </label>
              </div>
              <div className="col-12">
                <input
                  type="text"
                  id="Name"
                  className={`form-control ${errors.Name ? "is-invalid" : ""
                    }`}
                  aria-describedby="Name"
                  value={formData.Name}
                  name="Name"
                  onChange={handleFormChange}
                />
                {errors.Name && (
                  <div className="error">{errors.Name}</div>
                )}
              </div>
            </div>
            <div className="col-4">
              <div className="col-12">
                <label htmlFor="Description" className="col-form-label">
                  <strong>Description</strong>
                </label>
              </div>
              <div className="col-12">
                <input
                  type="text"
                  id="Description"
                  className={`form-control `}
                  name="Description"
                  aria-describedby="Description"
                  value={formData.Description}
                  onChange={handleFormChange}
                />
              </div>
            </div>
          </div>
          <div className="row ">

            <div className="col-4">
              <label htmlFor="FromDate" className="col-form-label">
                <strong>
                  From Date<span className="required">*</span>
                </strong>
              </label>

              <CustomDatePicker
                name="FromDate"
                handleChange={handleFormChange}
                className={`form-control ${errors.FromDate ? "is-invalid" : ""
                  }`}
                value={formData.FromDate}
              />
              <div>
                {errors.FromDate && (
                  <div className="error">
                    {errors.FromDate}{" "}
                    {/* Directly display the error message */}
                  </div>
                )}
              </div>
            </div>
            <div className="col-4">
              <label htmlFor="ToDate" className="col-form-label">
                <strong>
                  To Date<span className="required">*</span>
                </strong>
              </label>

              <CustomDatePicker
                name="ToDate"
                handleChange={handleFormChange}
                className={`form-control ${errors.ToDate ? "error" : ""}`}
                value={formData.ToDate}
              />

              {errors.ToDate && <div className="error">{errors.ToDate}</div>}
            </div>

            <div className="col-4 mt-4 pt-1 d-flex justify-content-between">
              <div className="ms-4">

                <input
                  className="me-2 form-check-input"
                  type="checkbox"
                  name="Active"
                  id="flexSwitchCheckChecked"
                  checked={formData.Active === 1}
                  onChange={(e) =>
                    handleFormChange({
                      target: {
                        name: e.target.name,
                        value: e.target.checked ? 1 : 0,
                      },
                    })
                  }
                /> <label className="form-label">Active</label>
              </div>
              <div className="me-4">
                <label htmlFor="ToDate" className="col-form-label">
     <strong>Appraisal Type<span className="required">*</span></strong>                </label>
                <div className="ms-2">
                  <input
                    type="radio"
                    className="form-check-input me-2"
                    name="AppraisalCycleProcessType"
                    onChange={handleFormChange}
                    value="old"
                  />
                  <span className="me-2">Old</span>
                  <input
                    type="radio"
                    className="form-check-input me-2"
                    name="AppraisalCycleProcessType"
                    onChange={handleFormChange}
                    value="new"
                  />
                  <span>New</span>
                </div>
                <span class="error">{errors?.AppraisalCycleProcessType}</span>

              </div>
            </div>






          </div>

          <div className="row mb-2">
            {/* <div className="col-4">
              <label htmlFor="ToDate" className="col-form-label">
                <strong>Appraisal Type</strong>
              </label>

              <div className="ms-2">
                <input
                  type="radio"
                  className="form-check-input me-2"
                  name="AppraisalCycleProcessType" // Removed extra space
                  onChange={handleFormChange}
                  value="old"
                />
                <span className="me-2">Old</span>
                <input
                  type="radio"
                  className="form-check-input me-2"
                  name="AppraisalCycleProcessType" // Removed extra space
                  onChange={handleFormChange}
                  value="new"
                />
                <span>New</span>
              </div>
            </div> */}
            {
              formData?.AppraisalCycleProcessType != "old"
                ?
                <div className="col-4">
                  <label class="col-form-label">
                    <strong>

                      Appraisal Cycle Type
                    </strong><span className="required">*</span>
                  </label>
                  <Select
                    name="AppraisalCycleType"
                    // onChange={handleState}
                    onChange={(e, action) => handleSelect(e, action.name)}
                    value={
                      formData.AppraisalCycleType == null
                        ? ""
                        : appraisalCycleTypeOption.find(
                          (o) => o.value == formData.AppraisalCycleType
                        )
                    }
                    className={` ${errors.AppraisalCycleType ? "is-invalid" : ""}`}
                    class="form-control"
                    options={appraisalCycleTypeOption}
                  />{" "}
                  <span class="error">{errors?.AppraisalCycleType}</span>
                </div>
                :
                null
            }

          </div>

          {/* //Assign Template */}
          <div>
            <div className="mt-2">
              <h4>Assign Template</h4>
            </div>

            <div>
              <div className="table-responsive poc-head rounded mt-2">
                <button
                  type="button"
                  onClick={handleAddAppraisalLine}
                  className="custom-btn mb-2 pull-right "
                >
                  <i className="fa fa-plus"></i>&nbsp;Add
                </button>
                <Table
                  style={{ background: "#ECECEC !important" }}
                  className="table table-bordered"
                >
                  <thead id="thcolor" className="text-center align-middle">
                    <tr>
                      <th>Sr. No.</th>
                      <th>Template</th>
                      <th>Employee</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody className="text-center align-middle">
                    {formData.lines.map((tempLine, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <Select
                            options={templateOption}
                            value={templateOption.find(
                              (option) =>
                                option.ID ===
                                tempLine.AppraisalTemplateMasterID
                            )}
                            menuPortalTarget={document.body}
                            styles={{
                              menuPortal: (base) => ({
                                ...base,
                                zIndex: 1050,
                              }),
                            }}
                            onChange={(selectedOption) =>
                              handleAppraisalLineSelectChange(
                                selectedOption,
                                "AppraisalTemplateMasterID",
                                index
                              )
                            }
                            placeholder="Select Template"
                          // isClearable
                          />
                        </td>
                        <td style={{ width: "40%" }}>
                          <Select
                            options={EmployeeListdata}
                            isMulti
                            closeMenuOnSelect={false}
                            hideSelectedOptions={false}
                            value={
                              (() => {
                                if (tempLine.EmployeeID && tempLine.EmployeeID !== "") {
                                  const selectedValues = tempLine.EmployeeID.split(",");

                                  const allEmployeeValues = EmployeeListdata
                                    .filter(opt => opt.value !== "")
                                    .map(opt => opt.value.toString());

                                  const allSelected = allEmployeeValues.length > 0 &&
                                    allEmployeeValues.every(v => selectedValues.includes(v));

                                  // If all employees selected, also include "Select ALL"
                                  return EmployeeListdata.filter(
                                    opt => opt.value !== "" && selectedValues.includes(opt.value.toString())
                                  ).concat(allSelected ? [EmployeeListdata.find(opt => opt.value === "")] : []);
                                }
                                return [];
                              })()
                            }
                            components={{ Option }}
                            menuPlacement="auto"
                            menuPortalTarget={document.body}
                            styles={{
                              option: (base, state) => ({
                                ...base,
                                backgroundColor: state.isSelected ? "#27568c" : "transparent",
                                color: state.isSelected ? "#ffffff" : "#000000",
                                '&:hover': {
                                  backgroundColor: "#e6f0fa",
                                },
                              }),
                              container: (base) => ({
                                ...base,
                                width: "100%",
                              }),
                              menuList: (base) => ({
                                ...base,
                                maxHeight: "300px",
                                overflowY: "auto",
                              }),
                            }}
                            className="basic-multi-select"
                            classNamePrefix="select"
                            onChange={(selected, actionMeta) => {
                              let newValue = "";

                              if (actionMeta.action === 'select-option' && actionMeta.option?.value === "") {
                                // Select ALL
                                const allEmployees = EmployeeListdata.filter(emp => emp.value !== "");
                                newValue = allEmployees.map(emp => emp.value).join(",");
                              }
                              else if ((actionMeta.action === 'remove-value' && actionMeta.removedValue?.value === "") ||
                                (actionMeta.action === 'deselect-option' && actionMeta.option?.value === "") ||
                                selected === null) {
                                // Clear ALL
                                newValue = "";
                              }
                              else {
                                // Normal selection
                                const filteredSelected = selected ? selected.filter(item => item.value !== "") : [];
                                newValue = filteredSelected.map(item => item.value).join(",");
                              }

                              handleAppraisalLineSelectChangeEmp(newValue, "EmployeeID", index);
                            }}
                            placeholder="Select Employee"
                          />

                        </td>

                        <td className="text-center align-middle">
                          <div
                            type="button"
                            onClick={() => handleDeleteAppraisalLine(index)}
                          >
                            <i
                              className="bi bi-trash"
                              style={{ fontSize: "1.2rem" }}
                            ></i>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </div>

          <div className="text-end mb-2">
            <button
              type="button"
              className="cancel-btn mt-3 me-2"
              onClick={() => navigate("/appraisal-cycles")}
            >
              Cancel
            </button>
            <button
              type="button"
              disabled={loading ? true : false}
              className="custom-btn me-2"
              onClick={handleSubmit}
            >
              {loading ? <FaSpinner class="sm-spinner" /> : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default Add_PR_Appraisal;
